<template>
  <el-button-group style="min-width: 96px;" size="mini" v-if="$store.state.uiConfig.reportModeSwitch !== 'off'"
    class="M_R_15">
    <el-button :class="{ ztBtn: $store.state.systemType == 'zongteng' }" :type="styleType == 'table' ? 'primary' : ''"
      size="mini" @click="styleType = 'table'">
      <img height="12" v-if="styleType == 'grid'" src="../assets/svg/row_u.svg" />
      <img height="12" v-else src="../assets/svg/row.svg" />
    </el-button>
    <el-button :type="styleType == 'grid' ? 'primary' : ''" size="mini" @click="styleType = 'grid'">
      <img height="12" v-if="styleType == 'grid'" src="../assets/svg/clo.svg" />
      <img height="12" v-else src="../assets/svg/clo_u.svg" />
    </el-button>
  </el-button-group>
</template>
<script>
export default {
  name: "GridToggle",
  data() {
    return {};
  },
  computed: {
    styleType: {
      get() {
        return this.$store.state.reportStyleType;
      },
      set(newVal) {
        this.$store.commit("setReportStyleType", newVal);
      },
    },
  },
};
</script>